import Storage from "./localStorage";
import Merkliste from "./module/merkliste";
import Notify from "./module/notify";

const notify = new Notify();
const storage = new Storage();
const merkliste = new Merkliste();


const alpineData = () => {
  return {
    isLoggedIn: wp_metis.isLoggedIn == '1' ? true : false,
    justLoggedInWithGuestList: false,

    guestMerklisteKey: null,
    merkliste: null,
    courseIds: [],
    coursesImageUrls: [],
    courseInMerkliste: false,

    initMerkliste: async function() {

      this.guestMerklisteKey = storage.getGuestMerklisteKey();
      this.checkIfjustLoggedInWithGuestList();

      if (this.justLoggedInWithGuestList) {
        console.log('Just Logged in with Guest List, overwrite profileList');
        const key = await merkliste.addGuestMerklisteToProfilMerkliste(this.guestMerklisteKey);

        if (key) {
          this.updateList();
          storage.removeGuestMerklisteKey();
          this.guestMerklisteKey = null;
        }
      } else {

        if (this.isLoggedIn) {
          // console.log('Logged in, UpdateList and remove guestKey');
          this.updateList();
          storage.removeGuestMerklisteKey();

        } else {
          if (this.guestMerklisteKey) {
            // console.log('Not Logged in, UpdateList');
            this.updateList()
          } else {
            // console.log('Not Logged in, dont UpdateList');
          }
        }
      }
    },

    updateList: async function () {

      let getMerklisteFunc = () => null;
      if (this.isLoggedIn) {
        getMerklisteFunc = merkliste.getProfilMerkliste;
      } else {
        getMerklisteFunc = merkliste.getGuestMerkliste;
      }

      const merkListe = await getMerklisteFunc(this.guestMerklisteKey);
      if (merkListe) {
        this.merkliste = merkListe;
        if (this.coursesImageUrls.length > 0) {
          this.insertProductDataForImages();
        }
      } else {
        this.merkliste = null;
      }
      this.courseIds = this?.merkliste?.kurse ? this.merkliste.kurse.map(kurs => kurs.kurs.kursnr) : [];
    },

    addCourseToMerkliste: async function (kursnr) {

      let addToMerklisteFunction = () => null;
      if (this.isLoggedIn) {
        addToMerklisteFunction = merkliste.addKursToProfilMerkliste;
      } else {
        addToMerklisteFunction = merkliste.addKursToGuestMerkliste;
      }

      const addToMerkliste = addToMerklisteFunction(kursnr, this.guestMerklisteKey);
      const responseAddToMerkliste = await addToMerkliste;

      if (responseAddToMerkliste) {
        if(!this.isLoggedIn && responseAddToMerkliste.merklisteKey) {
          storage.storeGuestMerklisteKey(responseAddToMerkliste.merklisteKey);
          this.guestMerklisteKey = responseAddToMerkliste.merklisteKey;
        }
        if (this.isLoggedIn) {
          this.merkliste = await merkliste.getProfilMerkliste();
        } else {
          this.merkliste = await merkliste.getGuestMerkliste(this.guestMerklisteKey);
        }

        console.log(this.merkliste);

        this.courseIds = this?.merkliste?.kurse ? this.merkliste.kurse.map(kurs => kurs.kurs.kursnr) : [];
        notify.emit([
          {
            message: "Zu den Favoriten hinzugefügt",
            status: "success",
          },
        ]);
      }
    },

    removeCourseFromMerkliste: async function (kursnr, removeHtml = false) {
      if (
        this.merkliste &&
        this.merkliste.kurse &&
        this.merkliste.merklisteKey
      ) {

        let removeFunction = () => null;
        if (this.isLoggedIn) {
          removeFunction = merkliste.deleteKursFromProfilMerkliste;
        } else {
          removeFunction = merkliste.deleteKursFromGuestMerkliste;
        }
        const removeFromMerkliste = removeFunction(this.merkliste.merklisteKey, kursnr);
        const removeFromMerklisteResponse = await removeFromMerkliste;
        console.log(removeFromMerklisteResponse);
        if (removeFromMerklisteResponse) {
          this.courseInMerkliste = false;
          notify.emit([
            {
              message: "Aus den Favoriten entfernt",
              status: "success",
            },
          ]);
          this.updateList();

          if (removeHtml) {
            const htmlCourse = document.querySelector('.course[data-courseid="' + kursnr + '"]');
            if (htmlCourse && htmlCourse.parentNode) {
              htmlCourse.parentNode.remove();
            }
          }
        }
      }
    },

    courseIsInList: function(kursnr) {
      return this.courseIds ? this.courseIds.includes(kursnr) : false;
    },

    jqueryAjaxCallForImage: function (productKeys) {
      const result = jQuery.ajax({
        type: "post",
        url: ajaxurl,
        data: {
          action: "get_posts_for_course_images",
          data: { productKeys: productKeys },
        },
        success: function (response) {
          return response;
        },
        error: function (error) {
          console.log("Error", error);
          return false;
        },
      });
      return result;
    },

    getProductDataForImages: async function () {
      let productKeys = [];
      if (this.merkliste && this.merkliste.kurse.length > 0) {
        this.merkliste.kurse.forEach((c) => {
          if (c.kurs.produkt.produktnr) {
            productKeys.push(c.kurs.produkt.produktnr);
          }
        });
      }
      if (productKeys && productKeys.length > 0) {
        const response = await this.jqueryAjaxCallForImage(productKeys);
        const result = JSON.parse(response);
        this.coursesImageUrls = result;
        this.insertProductDataForImages();
      }
    },

    insertProductDataForImages: function () {
      this.coursesImageUrls.forEach((resultObject) => {
        this.merkliste.kurse.forEach((c, cIndex) => {
          if (c.kurs.produkt.produktnr == resultObject.produktnr) {
            this.merkliste.kurse[cIndex].imageUrl = resultObject.url;
          }
        });
      });
    },

    checkIfjustLoggedInWithGuestList: function() {
      if (this.isLoggedIn && this.guestMerklisteKey) {
        this.justLoggedInWithGuestList = true;
      }
    },

    returnNull: async function() {
      return null;
    }
  };
};

if(!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.appMerkliste = alpineData;
